(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["em-sibling-swatches"] && !Shopify.designMode) return;
  try {
    // PDP: variant-picker内のColorフィールドセットを非表示（台湾では通常不要だが念のため日本と同様に用意）
  (function () {
    function hidePdpColorFieldset() {
      var variantPicker = document.querySelector('variant-picker');
      if (!variantPicker) return;
      if (!document.querySelector('.em-swatches--pdp')) return;
      variantPicker.querySelectorAll('fieldset').forEach(function (fs) {
        var legend = fs.querySelector('legend');
        if (legend && legend.textContent.trim() === 'Color') {
          fs.style.setProperty('display', 'none', 'important');
        }
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () {
        hidePdpColorFieldset();
        var picker = document.querySelector('variant-picker');
        if (picker) new MutationObserver(hidePdpColorFieldset).observe(picker, { childList: true, subtree: true });
      });
    } else {
      hidePdpColorFieldset();
      var picker = document.querySelector('variant-picker');
      if (picker) new MutationObserver(hidePdpColorFieldset).observe(picker, { childList: true, subtree: true });
    }
  })();
  } catch(e) { console.error(e); }
})();

})();
